import React from 'react';
import { Dialog, DialogContent } from '@mui/material';
import ItemFormUnified from './ItemFormUnified';
import PrintLabelDialog from './PrintLabelDialog';

const InventoryDialogs = ({
  isInventory,
  showForm,
  bulkEntryMode,
  setBulkEntryMode,
  setShowForm,
  formData,
  onInputChange,
  onSubmit,
  isSubmitting,
  channels,
  editingItem,
  editFormData,
  onEditInputChange,
  onEditSubmit,
  onCancelEdit,
  onImageUpload,
  onImageDelete,
  onSetMainImage,
  selectedChannelId,
  fetchNextItemNumber,
  onPrintLabel,
  printLabelItems,
  onClosePrintLabel,
  isLoadingEditImages = false,
}) => {
  if (!isInventory) return null;

  return (
    <>
      {showForm && (
        <Dialog
          open={showForm}
          onClose={() => {
            if (bulkEntryMode) {
              setBulkEntryMode(false);
            } else {
              setShowForm(false);
            }
          }}
          maxWidth="md"
          fullWidth
        >
          <DialogContent sx={{ pt: 3 }}>
            <ItemFormUnified
              formData={formData}
              onInputChange={onInputChange}
              onSubmit={onSubmit}
              isSubmitting={isSubmitting}
              isEditMode={false}
              bulkEntryMode={bulkEntryMode}
              showForm={showForm}
              setShowForm={setShowForm}
              setBulkEntryMode={setBulkEntryMode}
              channels={channels}
              selectedChannelId={selectedChannelId}
              fetchNextItemNumber={fetchNextItemNumber}
            />
          </DialogContent>
        </Dialog>
      )}

      {editingItem && (
        <Dialog
          open={!!editingItem}
          onClose={onCancelEdit}
          maxWidth="md"
          fullWidth
        >
          <DialogContent sx={{ pt: 3 }}>
            <ItemFormUnified
              formData={editFormData}
              onInputChange={onEditInputChange}
              onSubmit={onEditSubmit}
              isSubmitting={isSubmitting}
              isEditMode={true}
              onCancel={onCancelEdit}
              channels={channels}
              onImageUpload={onImageUpload}
              onImageDelete={onImageDelete}
              onSetMainImage={onSetMainImage}
              fetchNextItemNumber={fetchNextItemNumber}
              onPrintLabel={onPrintLabel}
              isLoadingImages={isLoadingEditImages}
            />
          </DialogContent>
        </Dialog>
      )}

      <PrintLabelDialog
        open={!!printLabelItems && printLabelItems.length > 0}
        onClose={onClosePrintLabel}
        items={printLabelItems || []}
      />
    </>
  );
};

export default InventoryDialogs;
